export default __webpack_public_path__ + "static/media/iconSuccessRate.1950e558.svg";